import { useGetUserBalance, useRefreshBalance } from '@/service/payment/hook';
import { fCurrencyUSDExtended } from '@/utils/formatNumber';
import { Coins, RefreshCw } from 'lucide-react';
import { Link } from 'react-router-dom';
import PATH_PAGE from '@/router/path';
import { Skeleton } from '@/components/ui/skeleton';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

const ViewCreditMini = () => {
  const { data, isLoading } = useGetUserBalance();
  const { mutate: refreshBalance, isPending: isRefreshing } = useRefreshBalance();
  const totalAvailableCredit = data?.balance ?? 0;

  const handleRefresh = (e: React.MouseEvent) => {
    e.preventDefault(); // Prevent navigation to payment page
    e.stopPropagation();
    refreshBalance();
  };

  return (
    <TooltipProvider>
      <div className="flex items-center gap-1">
        <Tooltip>
          <TooltipTrigger asChild>
            <Link
              to={PATH_PAGE.setting.payment}
              className="flex items-center gap-1.5 rounded-md border px-2.5 py-1.5 text-sm hover:bg-muted transition-colors"
            >
              <Coins className="h-4 w-4 text-muted-foreground" />
              {isLoading ? (
                <Skeleton className="h-4 w-12" />
              ) : (
                <span className={totalAvailableCredit <= 0 ? 'text-destructive font-medium' : 'font-medium'}>
                  {fCurrencyUSDExtended(totalAvailableCredit)}
                </span>
              )}
            </Link>
          </TooltipTrigger>
          <TooltipContent>
            <p>Credit Balance</p>
          </TooltipContent>
        </Tooltip>

        <Tooltip>
          <TooltipTrigger asChild>
            <button
              onClick={handleRefresh}
              disabled={isRefreshing}
              className="p-1.5 rounded-md hover:bg-muted transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              aria-label="Refresh balance"
            >
              <RefreshCw
                className={cn(
                  'h-4 w-4 text-muted-foreground',
                  isRefreshing && 'animate-spin'
                )}
              />
            </button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Refresh balance</p>
          </TooltipContent>
        </Tooltip>
      </div>
    </TooltipProvider>
  );
};

export default ViewCreditMini;
